class MarketProducts {

  constructor(basePath, userBasePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/market-products`;
    this.userBasePath = `${userBasePath}/market-products`;

  }

  async bootstrap(query, urlParameters) {

    const path = `${this.userBasePath}/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  async getOrCreateProductDraft() {

    const path = `${this.userBasePath}/drafts`;

    return this.apiClient.post(path, {}, {}, {});

  }

  async updateProductDraft(data) {

    const path = `${this.userBasePath}/drafts`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async createStandardProduct(data) {

    const path = `${this.userBasePath}/standard`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async copyProduct(marketProductId) {

    const path = `${this.userBasePath}/:marketProductId/copy`;

    return this.apiClient.post(path, { marketProductId }, {}, {});

  }

  async updateMarketProductById(marketProductId, data) {

    const path = `${this.userBasePath}/:marketProductId`;

    return this.apiClient.put(path, { marketProductId }, {}, data);

  }

  async updateHardProductMetricAllowedCount(marketProductId, metricName, data) {

    const path = `${this.userBasePath}/:marketProductId/metrics/:metricName`;

    return this.apiClient.put(path, { marketProductId, metricName }, {}, data);

  }

  async setMarketProductStatusById(marketProductId, status) {

    const path = `${this.userBasePath}/:marketProductId/status`;

    return this.apiClient.put(path, { marketProductId }, {}, { status });

  }

  async getMarketProductById(marketProductId) {

    const path = `${this.userBasePath}/:marketProductId`;

    return this.apiClient.get(path, { marketProductId }, {});

  }

  async getActiveMarketProductsByQueryOptions(queryOptions) {

    const path = `${this.userBasePath}`;

    return this.apiClient.get(path, {}, queryOptions);

  }

}

export default MarketProducts;